// Hover effect for list items - applies opacity 0.5 to siblings on hover
// Only applies on screens with minimum width of 1200px
document.addEventListener( 'DOMContentLoaded', function() {
  function setSiblingOpacity( listItems, targetItem, opacity ) {
    Array.from( listItems ).forEach( sibling => {
      if ( sibling !== targetItem && sibling.tagName === 'LI' ) {
        sibling.style.opacity = opacity;
      }
    } );
  }

  function resetAllOpacity( listItems ) {
    Array.from( listItems ).forEach( item => {
      if ( item.tagName === 'LI' ) {
        item.style.opacity = '1';
      }
    } );
  }

  function addHoverListeners( container ) {
    const listItems = container.children;
    
    Array.from( listItems ).forEach( item => {
      if ( item.tagName !== 'LI' ) return;
      
      item.addEventListener( 'mouseenter', () => setSiblingOpacity( listItems, item, '0.5' ) );
      item.addEventListener( 'mouseleave', () => resetAllOpacity( listItems ) );
    } );
    
    container.addEventListener( 'mouseleave', () => resetAllOpacity( listItems ) );
  }

  function initHoverSiblingOpacity() {
    if ( window.innerWidth < 1200 ) return;
    
    const containers = document.querySelectorAll( '#mega-menu-main-menu' );
    containers.forEach( addHoverListeners );
  }

  function cleanupStyles() {
    const listItems = document.querySelectorAll( '#mega-menu-main-menu > li' );
    listItems.forEach( item => item.style.opacity = '' );
  }

  function handleResize() {
    clearTimeout( resizeTimeout );
    resizeTimeout = setTimeout( () => {
      cleanupStyles();
      initHoverSiblingOpacity();
    }, 250 );
  }

  let resizeTimeout;
  
  initHoverSiblingOpacity();
  window.addEventListener( 'resize', handleResize );
} );
